const NAME = "GEOGRAPHICAL_STRUCTURE";

export default NAME;
